require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-why-i-dont-teach-breathing-correctly.json") })
        }
      }, "path---blog-why-i-dont-teach-breathing-correctly");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-why-i-dont-teach-breathing-correctly!./.cache/json/blog-why-i-dont-teach-breathing-correctly.json
// module id = 312
// module chunks = 231608221292675